// frontend/src/authConfig.ts

import { LogLevel, Configuration } from "@azure/msal-browser";

const tenantSubdomain = "architectiqapp";
const tenantId = "b3a84f57-544d-485a-9b90-0dc96f84cd12";
export const clientId = "8e8e1de0-ac7c-44d4-9969-fb49eedbd736";
const backendClientId = "e65b1c69-f5ba-4157-8cda-fe7811d71b80";

export const msalConfig: Configuration = {
    auth: {
        clientId: clientId,
        authority: `https://${tenantSubdomain}.ciamlogin.com/${tenantId}`,
        knownAuthorities: [`${tenantSubdomain}.ciamlogin.com`],
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        // --- REFACTORED: Zabezpieczenie przed trybem Incognito i blokadą 3rd-party cookies ---
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) { return; }
                switch (level) {
                    case LogLevel.Error: console.error(message); return;
                    case LogLevel.Info: console.info(message); return;
                    case LogLevel.Verbose: console.debug(message); return;
                    case LogLevel.Warning: console.warn(message); return;
                    default: return;
                }
            },
        },
    },
};

export const apiScopes = [`api://${backendClientId}/.default`];

export const loginRequest = {
    scopes: apiScopes
};